import { ChevronDown } from 'lucide-react';
import { cx } from './cx';
import styles from './Disclosure.module.css';

/** Einklappbarer Abschnitt (z. B. Kommentare, Verlauf) mit optionalem Zähler */
export function Disclosure({ icon: Icon, label, count, open, onToggle, children }) {
  return (
    <div className={styles.root}>
      <button type="button" className={styles.button} aria-expanded={open} onClick={onToggle}>
        {Icon && <Icon aria-hidden className={styles.icon} />}
        {label}
        {count > 0 && <span className={styles.count}>{count}</span>}
        <ChevronDown aria-hidden className={cx(styles.chevron, open && styles.open)} />
      </button>
      {open && <div className={styles.body}>{children}</div>}
    </div>
  );
}
